export const getArtworkImageSrc = (artwork) => {
  if (!artwork) return '';
  if (artwork.imageUrl) return artwork.imageUrl;
  if (artwork.image) return artwork.image;
  if (artwork.imageData && artwork.imageMimeType) {
    return `data:${artwork.imageMimeType};base64,${artwork.imageData}`;
  }
  if (artwork.imageBase64) {
    return artwork.imageBase64.startsWith('data:')
      ? artwork.imageBase64
      : `data:image/jpeg;base64,${artwork.imageBase64}`;
  }
  return '';
};
